(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("prop-types"), require("styled-components"), require("@ls/react-tooltip"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "prop-types", "styled-components", "@ls/react-tooltip"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("react"), require("prop-types"), require("styled-components"), require("@ls/react-tooltip")) : factory(root["react"], root["prop-types"], root["styled-components"], root["@ls/react-tooltip"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__2__, __WEBPACK_EXTERNAL_MODULE__3__) {
return 